import type { FaireProductEntity } from "../../entity_types/product";

export const p_58w27bfxkb: FaireProductEntity = {
  token: "p_58w27bfxkb",
  type: "product",
  name: "Gathered Waist Midi Dress - RD1199",
  brandToken: "b_a7rynywhaw",
  brandName: "RAISONNEL",
  imageUrl:
    "https://cdn.faire.com/fastly/5287bfc0ee297b0a12ce3c0ccde296d34eef418066c2565b6cb0d2d2d97b2089.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/00750d86c7ca300f1328e81305bd79500514245496844fa1160ecbcbeb8e59fd.jpeg",
    "https://cdn.faire.com/fastly/ff4e743d1119acf6a0e8750c3d75459767f363df198c5535e4f5c7662565dc33.jpeg",
    "https://cdn.faire.com/fastly/eb49da9836f8e3b487a0fdf892f622eccc91a867c97d8b3ad42c720b5d1f1681.jpeg",
    "https://cdn.faire.com/fastly/c5fb251e88a7530bc5dba310e502ffa9c62d627f675689eaa2389f6c68a3536c.jpeg",
    "https://cdn.faire.com/fastly/54f12cf0a91aa6e2909aa6f863615cd74f25224242b37a4addc15189f6990c14.jpeg",
    "https://cdn.faire.com/fastly/32ba3efa21567fdc403678824998a0b4d9a9ab385836857c00dc9809d84c9038.jpeg",
  ],
  priceDollars: 36.5,
  description:
    "Crafted from a lightweight woven fabric, this dress is designed with wide shoulder straps, a clean scoop neckline, and subtle side gathering that adds movement and dimension.\nIts easy, flowy shape makes it perfect for warm-weather days, vacation style, or elevated everyday dressing. Plus, hidden side pockets add functionality without compromising the clean lines.\n\n• Lightweight woven fabric\n• Fitted bodice with gathered skirt\n• Wide shoulder straps & scoop neckline\n• Hidden side pockets\n• Flowy A-line maxi silhouette\n• Center back zipper\n\nModel: 170 cm (5'7\") wearing size Small\n\n60% Cotton 37% Nylon 3% Spandex",
  tags: [],
  msrpDollars: 73,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:53.443Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
